// Émission d'une facture / proforma : réservée aux valideurs désignés (Kane, PDG, DGA…).
import React, { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { ForwardToInboxOutlined, VerifiedOutlined } from '@mui/icons-material';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

/** Bouton « Valider et émettre » pour un valideur ; sinon, bandeau « en attente de validation ». */
export const ValiderEmettre = ({ label = 'la facture', onEmit, busy }) => {
  const { canValiderFactures } = useAuth();
  if (!canValiderFactures) return null;
  return (
    <Button variant="contained" startIcon={<VerifiedOutlined />} disabled={busy}
      onClick={() => window.confirm(`Valider et émettre ${label} ? Elle recevra son numéro définitif, à votre nom, et ne pourra plus être modifiée.`) && onEmit()}>
      Valider et émettre
    </Button>
  );
};

/** Comptable : envoie (ou renvoie) l'alerte email aux valideurs. */
export const DemanderValidation = ({ kind = 'invoices', id, doc, onDone }) => {
  const { canCompta } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!canCompta) return null;
  const deja = !!doc?.validation_demandee_le;
  return (
    <Button variant={deja ? 'outlined' : 'contained'} startIcon={<ForwardToInboxOutlined />} disabled={busy}
      onClick={async () => {
        setBusy(true);
        try { const r = await api.post(`/${kind}/${id}/demander-validation`); onDone?.(r.data.message, r.data.echecs?.length || !r.data.configure ? 'warning' : 'success'); }
        catch (e) { onDone?.(e.response?.data?.error || 'Erreur', 'error'); }
        finally { setBusy(false); }
      }}>
      {deja ? 'Relancer la validation' : 'Demander la validation'}
    </Button>
  );
};

export const AttenteValidation = ({ kind = 'invoices', doc }) => {
  const { canValiderFactures } = useAuth();
  const invite = new URLSearchParams(window.location.search).has('valider');
  const demande = doc?.validation_demandee_le
    ? <> Validation demandée le {new Date(doc.validation_demandee_le).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}{doc.validation_demandee_par_nom ? ` par ${doc.validation_demandee_par_nom}` : ''}.</>
    : null;
  const [valideurs, setValideurs] = useState(null);
  useEffect(() => {
    if (canValiderFactures) return;
    api.get(`/${kind}/valideurs`).then((r) => setValideurs(r.data)).catch(() => setValideurs([]));
  }, [kind, canValiderFactures]);
  if (canValiderFactures) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        {invite ? 'Vous êtes invité à valider ce document. ' : ''}Vérifiez-le (bouton « Aperçu » pour le voir tel qu'il sera imprimé), puis cliquez « Valider et émettre ».{demande}
      </Alert>
    );
  }
  if (!valideurs) return null;
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      Brouillon <b>en attente de validation</b> : seul un valideur désigné peut l'émettre
      {valideurs.length ? <> — {valideurs.map((v) => `${v.nom}${v.fonction ? ` (${v.fonction})` : ''}`).join(', ')}.</>
        : <>. Aucun valideur n'est encore désigné : l'administrateur doit en choisir dans Administration → Utilisateurs.</>}
      {demande || <> Cliquez « Demander la validation » pour les prévenir par email.</>}
    </Alert>
  );
};

export const ValideePar = ({ doc }) => (doc?.valide_nom ? (
  <Alert severity="success" icon={<VerifiedOutlined />} sx={{ mb: 2 }}>
    Validée et émise par <b>{doc.valide_nom}</b>{doc.emise_le ? ` le ${new Date(doc.emise_le).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}` : ''}.
  </Alert>
) : null);
